import type { Types } from '@fiverr-private/theme';
import type { BorderProps } from './types';

export const border: BorderProps = { borderColor: 'border', borderStyle: 'solid', borderWidth: 'sm' };
export const shadow: Types.Box = { boxShadow: 'aa' };
